import $http from './http'
import config from './config'

export default {
    name: 'express',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    getExpressList(data) {
        return $http.post(this.getUrl(`/ExpressOrder/List`), data);
    },
    getExpressOrder(TaskID) {
        return $http.get(this.getUrl(`/ExpressOrder/Details/${TaskID}`));
    },
    saveExpressOrder(data) {
        return $http.post(this.getUrl(`/ExpressOrder/Update`), data);
    },
    deleteExpressOrder(TaskID) {
        return $http.get(this.getUrl(`/ExpressOrder/Delete/${TaskID}`));
    },
    getExpressState(TaskID){
        return $http.get(this.getUrl(`/ExpressOrder/ExpressState/${TaskID}`));
    }
}



// WEBPACK FOOTER //
// ./src/apis/expressApis.js